export const possibleTypes = [
  'primary',
  'secondary',
  'prominent',
  'danger',
  'reverse',
];

export const sizes = ['sm', 'md', 'lg'];
export const variants = ['fill', 'outline', 'ghost'];
export const possibleWidth = [128, 160, 176, 192, 200, 232, 'hug', 'block'];
export const possibleSmWidth = ['hug', 'block'];
